// extracted by mini-css-extract-plugin
export default {"FaqAskQuestion":"os_a bhs_qt bhs_a bhs_w","FaqAskQuestion__outdated":"os_b bhs_vr bhs_xg"};